import React from 'react';

export default function AppInstallPage() {
    const appPath = new URLSearchParams(window.location.search).get('app') === 'portal' ? 'https://book.therideatl.com' : '/';
    return (
        <main className="page-frame" style={{ maxWidth: 640, margin: '2rem auto', padding: '1.5rem' }}>
            <h1>Install the app on your phone</h1>
            <p>No app-store download is needed for the web app. Open <a href={appPath}>the app</a> first, then follow these steps.</p>
            <h2>iPhone or iPad</h2>
            <ol>
                <li>Open the app in Safari.</li>
                <li>Tap Share, then Add to Home Screen, then Add.</li>
                <li>Open the new Home Screen icon and sign in.</li>
                <li>In your notification preferences, tap Turn on notifications on this device.</li>
            </ol>
            <p>iPhone notifications require iOS 16.4 or later and the installed Home Screen app.</p>
            <h2>Android</h2>
            <ol>
                <li>Open the app in Chrome.</li>
                <li>Tap the three-dot menu, then Install app or Add to Home screen.</li>
                <li>Open the new icon and sign in.</li>
                <li>In your notification preferences, tap Turn on notifications on this device.</li>
            </ol>
            <p>You can turn notifications off on the same device at any time. Signing out also turns off this browser subscription.</p>
        </main>
    );
}
